<template lang="pug">
    div(style="overflow-y:scroll;" @scroll="infiniteScroll($event)" :style="`height:${windowHeight - 210}px;`" class="company-news")
        NewsInformation(:company_id="company_id" ref="newsInformationElement")
</template>

<script>
import NewsInformation from "./NewsInformation.vue";

export default {
    name: 'CompanyNews',
    components: {
        NewsInformation
    },
    props: {
        company_id: {
            type: Number
        },
        stock_id: {
            type: Number
        }
    },
    data() {
        return {
            windowHeight: 0
        };
    },
    mounted() {
        this.setWindowHeight();
        window.addEventListener('resize', this.setWindowHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setWindowHeight);
    },
    methods: {
        setWindowHeight() {
            this.windowHeight = window.innerHeight;
        },
        infiniteScroll(event) {
            const element = event.target;

            if(element.offsetHeight + element.scrollTop >= element.scrollHeight - 200) {
                this.$refs.newsInformationElement.scrollCheck = 'scrolled to bottom';
                this.$refs.newsInformationElement.loadTheNews();
            }
        }
    }
}
</script>

<style scoped>
    .stock-section .news-list {
        padding-left: 2px;
    }
</style>
